import { z } from "zod";
import { ISODateSchema, ULIDSchema } from "./primitives.js";
import { ShoppingCategorySchema } from "../categories.js";
/** Lowercase, trim, collapse internal whitespace, naive singularization of words > 3 chars. */
export function normalizeItemName(name) {
    return name
        .toLowerCase()
        .trim()
        .replace(/\s+/g, " ")
        .split(" ")
        .map((w) => {
        if (w.length > 3 && w.endsWith("s") && !w.endsWith("ss") && !w.endsWith("us")) {
            // Strip "es" if it ends in "es", otherwise strip just "s"
            if (w.endsWith("es")) {
                return w.slice(0, -2);
            }
            return w.slice(0, -1);
        }
        return w;
    })
        .join(" ");
}
export function catalogSk(normalizedName) {
    return `item#${normalizedName}`;
}
const catalogCore = {
    schemaVersion: z.literal(1),
    normalizedName: z.string().min(1),
    displayName: z.string().min(1).max(200),
    category: ShoppingCategorySchema,
    lastUnit: z.string().max(32).nullable(),
    useCount: z.number().int().nonnegative(),
    updatedAt: ISODateSchema,
    deletedAt: ISODateSchema.nullable(),
    source: z.enum(["user", "seed-llm"]).optional(),
};
export const ItemCatalogRowSchema = z
    .object({ householdId: ULIDSchema("hh"), sk: z.string().startsWith("item#"), ...catalogCore })
    .passthrough();
export const ItemCatalogApiItemSchema = z
    .object({
    normalizedName: z.string().min(1),
    displayName: z.string().min(1).max(200),
    category: ShoppingCategorySchema,
    lastUnit: z.string().max(32).nullable(),
    useCount: z.number().int().nonnegative(),
    updatedAt: ISODateSchema,
})
    .passthrough();
export function catalogRowToApiItem(raw) {
    const row = ItemCatalogRowSchema.parse(raw);
    return ItemCatalogApiItemSchema.parse({
        normalizedName: row.normalizedName, displayName: row.displayName, category: row.category,
        lastUnit: row.lastUnit, useCount: row.useCount, updatedAt: row.updatedAt,
    });
}
export const ItemCatalogResponseSchema = z.object({
    items: z.array(ItemCatalogApiItemSchema),
    nextCursor: z.string().nullable().optional(),
});
//# sourceMappingURL=item-catalog.js.map